import React from 'react';
import { SalesforceFieldSearchableSelectionTableV3 } from '../../../general/fields';
import { SonarObjectTypeId } from '@sonar-software/sonar-ts-types';
import { useBulkSelectWorkflow } from '@hooks';

export interface PageLayoutFieldsTabsProps {
	index: number;
	sonarObjectId: number;
}

export const PageLayoutFieldsTab: React.FC<PageLayoutFieldsTabsProps> = ({ index, sonarObjectId }) => {
	const uri = `v3/salesforce/page-layouts/${sonarObjectId}/fields`;
	const { resourceIdsUri } = useBulkSelectWorkflow({
		childType: SonarObjectTypeId.SalesforceField,
		parentType: SonarObjectTypeId.SalesforcePageLayout,
		sonarObjectId
	});

	return <SalesforceFieldSearchableSelectionTableV3
		parentIndex={ index }
		resourceIdsUri={ resourceIdsUri }
		uri={ uri }
		useDql />;
};
